import request from './request'

export const fetchProducts = (products_id_list) => {
    return new Promise((resolve, reject) => {
        const list = products_id_list.join(',')
        request.get(`products`, {params: {'ids':list}})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const fetchProductsBySku = (products_id_list) => {
    return new Promise((resolve, reject) => {
        const list = products_id_list.join(',')
        request.get(`products/sku`, {params: {'skus':list}})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const searchProducts = (query)=>{
    return new Promise((resolve, reject) => {
        request.get(`products/search`, {params: {'s':query}})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
